module.exports = __webpack_public_path__ + "static/media/siddharth-amaravati-trip-15.77636a60.png";